module.exports = __webpack_public_path__ + "img/emo_29.f39d5759.png";